import {setupIndicator} from "../lib/input-maxlength-indicator";

function setupEntryCategorySwitching($container) {
	const $candidate_container = $container.querySelector('.ams-cpd-entry-form__field--cpd_categories');

	if (!$candidate_container) {
		return;
	}

	const $type_selector = $container.querySelector('[name="cpd_type"]');

	if (!$type_selector) {
		console.warn('Wanted to setup CPD Entry Categories selector behaviour, but could not discover the type selector field.');
		return;
	}

	// Get the default "no categories" selector, or fall back to an empty div for no content...
	const $no_categories_template = $candidate_container.querySelector('script[type="text/html"][data-ams-cpd-type-categories-selector="none"]')
		|| document.createElement('div');

	let $appended_elements = [];

	$type_selector.addEventListener('change', () => {
		const type = $type_selector.value || 'none';

		// Remove appended elements.
		$appended_elements.forEach($element => $element.remove());
		$appended_elements = [];

		// Try to find the HTML template...
		let $template = $candidate_container.querySelector(`script[type="text/html"][data-ams-cpd-type-categories-selector="${type}"]`);

		// If we couldn't find a template, or it didn't specify how many templates it has, use the no categories template.
		if (!$template || parseInt($template.dataset.amsCpdTypeCategoriesCount || 0) === 0) {
			$template = $no_categories_template;
		}

		const $transient = document.createElement('div');
		$transient.innerHTML = $template.innerHTML;

		// Append the transient elements to the container.
		$appended_elements = Array.from($transient.children);
		$appended_elements.forEach($element => $candidate_container.appendChild($element));

	});

	// Trigger a change to select the initial state.
	$type_selector.dispatchEvent(new Event('change'));
}

/**
 * Setup the candidate form container.
 * @param {HTMLElement} $container The container to setup.
 */
function setupCandidateForm($container) {
	if ($container.hasAttribute('data-ams-cpd-entry-form-setup')) {
		return;
	}

	$container.setAttribute('data-ams-cpd-entry-form-setup', 'true');

	// Setup text limit indicators...
	$container.querySelectorAll('[maxlength]')
		.forEach($element => setupIndicator($element));

	// Setup the entry category element behaviour - there is a different set of categories based on the type
	// which is selected.
	setupEntryCategorySwitching($container);
}

document.addEventListener('DOMContentLoaded', () => {
	const $candidates = document.querySelectorAll('.ams-cpd-entry-form');

	if ($candidates.length === 0) {
		return;
	}

	$candidates.forEach(setupCandidateForm);
});
